module.exports = __webpack_public_path__ + "static/Elixir-0e9a0a20ae93fdac45a544aac304f65d.png";